// Google Analytics 4 wrapper. Loads gtag.js only when a measurement ID is
// configured (REACT_APP_GA_MEASUREMENT_ID) AND this is a production build of
// the production environment, so `npm start` and build:dev deploys send nothing.
//
// Privacy rules — this app holds member and health data, none of it goes to
// Google:
//   - no names, mobile numbers, emails, or tokens in any event or property
//   - page paths are sent as their route PATTERN, never the real URL. URLs
//     here carry record ids and, on hand-off, a ?token= query param, so a
//     path that matches no known pattern is sent as "/(other)"
//   - the only user property is a coarse role (admin | client)
import { matchPath } from "react-router-dom";

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// Keep in sync with src/router/index.js and modules/member/routes/MemberRoutes.js.
const ROUTE_PATTERNS = [
  "/",
  "/logout",
  "/dashboard",
  "/members",
  "/practitioner",
  "/appointments",
  "/calender",
  "/settings",
  "/support",
  "/profile",
  "/bulk-student",
  "/add-member",
  "/add-practitioner",
  "/member-detail/:clientId",
  "/practitioner-detail/:counsellorId",
  "/appointment-detail/:appointmentId",
  "/member-summary-report/:appointmentId",
  "/schedule-wellness",
  "/schedule-health-camp",
  "/run-survey",
  "/user-risk",
  "/counsellor-managment",
  "/add-counsellor",
  "/kyc-users",
  "/member/dashboard",
  "/member/my-bookings",
  "/member/profile",
  "/member/support",
];

let initialized = false;

function gtag() {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(arguments);
}

export function initAnalytics() {
  if (
    initialized ||
    !GA_ID ||
    process.env.NODE_ENV !== "production" ||
    process.env.REACT_APP_ENV !== "production"
  )
    return;
  initialized = true;

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(script);

  gtag("js", new Date());
  // send_page_view off: the router fires page_view explicitly on every
  // route change (the initial load included), so we don't double-count.
  gtag("config", GA_ID, { send_page_view: false });
}

export function normalizePath(pathname) {
  const pattern = ROUTE_PATTERNS.find((p) => matchPath(p, pathname));
  return pattern || "/(other)";
}

export function trackPageView(pathname) {
  if (!initialized) return;
  const page_path = normalizePath(pathname);
  gtag("event", "page_view", {
    page_path,
    page_title: page_path,
    // Deliberately NOT window.location.href — real URLs carry ids/tokens.
    page_location: window.location.origin + page_path,
  });
}

export function trackEvent(name, params = {}) {
  if (!initialized) return;
  gtag("event", name, params);
}

// role: "ADMIN" | "CLIENT"
export function setAnalyticsRole(role) {
  if (!initialized || !role) return;
  gtag("set", "user_properties", { app_role: String(role).toLowerCase() });
}
